var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueShadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 95,
    viewBox: "0 0 107 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1264 3.34267C67.8167 -9.08194 73.2492 27.8439 97.1929 44.1051C129.339 65.9371 67.7876 108.075 70.4501 90.6905C70.4464 90.6925 70.4384 90.6968 70.4241 90.7044C70.4243 90.7035 70.4244 90.7027 70.4246 90.7019C77.1796 50.6578 16.4664 87.0202 4.54437 81.1882C-10.3584 73.8981 16.4254 13.3735 30.7431 23.6551C62.4878 46.4511 48.4362 15.7673 58.1264 3.34267Z",
    fill: "url(#paint0_linear_619_1756)",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1929 44.1051C73.2492 27.8439 67.8167 -9.08194 58.1264 3.34267C48.4362 15.7673 62.4878 46.4511 30.7431 23.6551C16.4254 13.3735 -10.3584 73.8981 4.54437 81.1882C16.4664 87.0202 77.1796 50.6578 70.4246 90.7019C70.4181 90.7048 70.4204 90.7032 70.4506 90.6871C70.4504 90.6882 70.4503 90.6893 70.4501 90.6905C67.7876 108.075 129.339 65.9371 97.1929 44.1051Z",
    fill: "url(#paint1_linear_619_1756)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_619_1756",
    x1: 74.1221,
    y1: 97.2593,
    x2: 25.1824,
    y2: 22.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_619_1756",
    x1: 74.1221,
    y1: 97.2593,
    x2: 25.1824,
    y2: 22.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D7E2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueShadow);
export default __webpack_public_path__ + "static/media/BlueShadow.ea4a706a0ab03ce8a19c6c93d0ecc3ec.svg";
export { ForwardRef as ReactComponent };